import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonModule } from '@angular/common';

import { NgSelectModule } from '@ng-select/ng-select';

// used to create fake backend
import { fakeBackendProvider } from './_helpers';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { JwtInterceptor, ErrorInterceptor } from './_helpers';
import { HomeComponent } from './home';
import { LoginComponent } from './login';

import { FormioModule } from '@formio/angular';
import { FormioTestComponent } from './formio-test';
import { IntroComponent } from './courses/sections/intro/intro.component';
import { AudioTranscriptComponent } from './courses/sections/audio-transcript/audio-transcript.component';
import { CourseComponent } from './courses/course.component';
import { TopicComponent } from './courses/sections/topic/topic.component';
import { NavigationProgressComponent } from './courses/navigation-progress/navigation-progress.component';
import { SectionComponent } from './courses/sections/section.component';
import { OverviewComponent } from './courses/sections/overview/overview.component';
import { PEBTopicComponent } from './courses/sections/peb-topic/peb-topic.component';
import { MeditationComponent } from './courses/meditation/meditation.component';
import { ConclusionComponent } from './courses/sections/conclusion/conclusion.component';
import { InCourseNavigationComponent } from './courses/incourse-navigation/incourse-navigation.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { JourneyComponent } from './dashboard/journey/journey.component';
import { DashboardHeaderComponent } from './dashboard/header/dashboard-header.component';
import { ResultsComponent } from './dashboard/results/results.component';
import { CommunityComponent } from './dashboard/community/community.component';
import { FormsModule } from '@angular/forms';
import { EditProfileComponent } from './dashboard/profile/edit-profile.component';
import { FlowerComponent } from './shared/flower.component';
import { PEBResultsComponent } from './dashboard/results/peb-results/peb-results.component';
import { SettingsComponent } from './dashboard/settings/settings.component';
import { ElementalInputComponent } from './elemental-input/elemental-input.component';
import { StatusComponent } from './dashboard/status.component';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { ProfileComponent } from './dashboard/profile/profile.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { SOISectionComponent } from './courses/sections/soi-section/soi-section.component';
import { ZipCodeSelectorComponent } from './courses/sections/zipcode-selector/zipcode-selector.component';

import { ImageUploadComponent } from './shared/image-upload/image-upload.component';
import { FrontlineCommunitiesComponent } from './courses/sections/frontline-data/community-score/frontline-communities.component';
import { FrontlineDataDistributionComponent } from './courses/sections/frontline-data/data-distribution/frontline-data-distribution.component';
import { SOIResultsComponent } from './dashboard/results/soi-results/soi-results.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { WorksheetComponent } from './courses/sections/worksheet/worksheet.component';

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        ReactiveFormsModule,
        HttpClientModule,
        AppRoutingModule,
        FormioModule,
        FormsModule,
        NgSelectModule
    ],
    declarations: [
        AppComponent,
        HomeComponent,
        LoginComponent,
        FormioTestComponent,
        IntroComponent, AudioTranscriptComponent, CourseComponent, TopicComponent, NavigationProgressComponent, SectionComponent, MeditationComponent,
        OverviewComponent, PEBTopicComponent, ConclusionComponent, InCourseNavigationComponent, 
        DashboardComponent, JourneyComponent, DashboardHeaderComponent, ResultsComponent, CommunityComponent, ProfileComponent, EditProfileComponent,
        FlowerComponent, PEBResultsComponent, SettingsComponent, ElementalInputComponent, StatusComponent, OnboardingComponent, FrontlineCommunitiesComponent,
        WelcomeComponent, SOISectionComponent, ZipCodeSelectorComponent, ImageUploadComponent, FrontlineDataDistributionComponent, SOIResultsComponent, ForgotPasswordComponent,
        PasswordResetComponent, WorksheetComponent
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

        // provider used to create fake backend
        fakeBackendProvider
    ],
    bootstrap: [AppComponent]
})

export class AppModule { }